import { useState } from 'react';
import { Btn } from './ui/Btn.jsx';
import { C } from '../theme/palette';

/**
 * Bouton qui fait partir une pièce par e-mail depuis le serveur.
 *
 * <p>À la différence des liens qui ouvrent la messagerie du téléphone, ici
 * c'est SwissTech qui envoie, PDF officiel joint, et qui l'inscrit au journal
 * des envois. Le résultat — parti, ou pourquoi pas — se lit sous le bouton.
 *
 * @param {object} props propriétés du bouton
 * @param {string} props.label libellé
 * @param {() => Promise<object>} props.envoie envoi, qui résout sur la ligne du journal
 * @param {string} [props.cible] adresse visée, rappelée sous le bouton
 * @param {string} [props.indisponible] pourquoi l'envoi n'est pas possible ; le bouton s'efface
 * @param {(ligne: object) => void} [props.onEnvoye] appelé une fois le message parti
 * @param {string} [props.color] couleur du bouton
 * @param {boolean} [props.sm] bouton compact
 * @returns {JSX.Element} le bouton et son état
 */
export function BoutonEnvoiServeur({ label, envoie, cible, indisponible, onEnvoye, color, sm }) {
  const [etat, setEtat] = useState('repos');
  const [message, setMessage] = useState('');

  const lance = async () => {
    setEtat('envoi');
    setMessage('');
    try {
      const ligne = await envoie();
      setEtat('envoye');
      setMessage('Envoyé à ' + (ligne?.destinataire || cible || 'l’adresse du client') + '.');
      if (onEnvoye) onEnvoye(ligne);
    } catch (e) {
      setEtat('echec');
      setMessage(e?.message || 'L’envoi a échoué.');
    }
  };

  if (indisponible) {
    return <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.5 }}>{indisponible}</div>;
  }

  return (
    <div>
      <Btn
        label={etat === 'envoi' ? '⏳ Envoi en cours…' : label}
        color={color || C.teal}
        full
        sm={sm}
        disabled={etat === 'envoi'}
        onClick={lance}
      />
      {cible && etat === 'repos' && (
        <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>
          PDF officiel joint · à {cible}
        </div>
      )}
      {message && (
        <div
          role="status"
          style={{
            fontSize: 11,
            fontWeight: 700,
            marginTop: 5,
            color: etat === 'echec' ? C.red : C.green,
          }}
        >
          {etat === 'echec' ? '✕ ' : '✓ '}
          {message}
        </div>
      )}
    </div>
  );
}
